import { combineReducers } from "redux"
import * as message from "./message"
import * as visual from "./visual"
import * as analysisTasks from "./analysisTasks"
import * as whiteTasks from "./whiteTasks"
import * as members from "./members"
import { externalBookingsReducer } from "./members"
import * as analyses from "./analyses"
import * as projectActions from "./projectActions"
import * as assets from "./assets"
import * as analysisDefinitions from "./analysisDefinitions"
import * as teamStatus from "./teamStatus"
import * as auth from "./auth"
import * as loading from "./loading"
import * as projects from "./projects"
import * as projectTemplates from "./projectTemplates"
import * as competenceGroups from "./competenceGroups"
import * as constraintChecks from "./constraintChecks"
import * as metrics from "./metrics"
import * as iap from "./iap"
import * as scheduleHover from "./scheduleHover"
import * as customerAdministration from "./customerAdministration"
import * as samples from "./samples"
import * as seatInfo from "./seatInfo"
import * as diagnostics from "./diagnostics"
import * as sampleView from "./sampleView"
import * as integrationSheets from "./integrationSheets"
import * as teamsOnLocation from "./teamsOnLocation"
import * as locations from "./locations"
import * as teamInfo from "./teamInfo"
import * as multipleDrag from "./multipleDrag"
import * as reports from "./reports"
import * as dayPicker from "./dayPicker"
import * as waiting from "./waiting"
import * as scrumView from "./scrumView"
import * as token from "./token"
import * as plannableSamples from "./plannableSamples"
import * as analysisGroups from "./analysisGroups"
import * as projectGroups from "./projectGroups"
import * as chatBot from "./chatBot"
import * as librarian from "./librarian"
import * as repositories from "./repositories"
import * as standardActions from "./standardActions"
import * as logging from "./logging"
import * as permissions from "./permissions"
import * as limsCapabilities from "./lims/limsCapabilities"
import * as limsAudit from "./lims/limsAudit"
import * as limsCommentLibrary from "./lims/limsCommentLibrary"
import * as limsSpecs from "./lims/limsSpecs"
import * as limsConsumables from "./lims/limsConsumables"
import * as limsProductTestPlan from "./lims/limsProductTestPlan"
import * as limsSampleQc from "./lims/limsSampleQc"
import * as limsOos from "./lims/limsOos"
import * as limsResults from "./lims/limsResults"
import * as limsRelease from "./lims/limsRelease"
// SPEC-038 (F6): sample/lot-level QA completeness selectors (no reducer — pure selectors over the
// existing limsResults / limsOos / limsReruns / limsProductTestPlan / sampleView slices).
import * as limsSampleQa from "./lims/limsSampleQa"
import * as limsReviewSpec from "./lims/limsReviewSpec"
import * as limsReviews from "./lims/limsReviews"
import * as limsSstSpec from "./lims/limsSstSpec"
import * as limsSstResult from "./lims/limsSstResult"
import * as limsSstTemplates from "./lims/limsSstTemplates"
import * as limsForskrifter from "./lims/limsForskrifter"
import * as limsSpecVersions from "./lims/limsSpecVersions"
import * as limsQaDecisions from "./lims/limsQaDecisions"
import * as limsBatchHold from "./lims/limsBatchHold"
import * as limsReruns from "./lims/limsReruns"
import * as limsWorklistTemplates from "./lims/limsWorklistTemplates"
import * as limsSampleWorklists from "./lims/limsSampleWorklists"
import * as limsChangeControl from "./lims/limsChangeControl"

import { createMap, addToMap, removeFromMap } from "./common"

export { MemberRoles } from "./members"

export const rootReducer = combineReducers({
  message: message.reducer,
  visual: visual.reducer,
  whiteTasks: whiteTasks.reducer,
  analysisTasks: analysisTasks.reducer,
  members: members.reducer,
  externalBookings: externalBookingsReducer,
  analyses: analyses.reducer,
  projectActions: projectActions.reducer,
  asset: assets.reducer,
  analysisDefinitions: analysisDefinitions.reducer,
  teamStatus: teamStatus.reducer,
  auth: auth.reducer,
  loading: loading.reducer,
  projects: projects.reducer,
  projectTemplates: projectTemplates.reducer,
  competenceGroups: competenceGroups.reducer,
  constraintChecks: constraintChecks.reducer,
  metrics: metrics.reducer,
  scheduleHover: scheduleHover.reducer,
  customerAdministration: customerAdministration.reducer,
  samples: samples.reducer,
  seatInfo: seatInfo.reducer,
  diagnostics: diagnostics.reducer,
  sampleView: sampleView.reducer,
  integrationSheets: integrationSheets.reducer,
  teamsOnLocation: teamsOnLocation.reducer,
  locations: locations.reducer,
  teamInfo: teamInfo.reducer,
  multipleDrag: multipleDrag.reducer,
  reports: reports.reducer,
  dayPicker: dayPicker.reducer,
  waiting: waiting.reducer,
  scrumView: scrumView.reducer,
  token: token.reducer,
  plannableSamples: plannableSamples.reducer,
  analysisGroups: analysisGroups.reducer,
  projectGroups: projectGroups.reducer,
  chatBot: chatBot.reducer,
  librarian: librarian.reducer,
  repositories: repositories.reducer,
  standardActions: standardActions.reducer,
  logging: logging.reducer,
  // limsCapabilities has no reducer since SPEC-021 (B3): QC capabilities are read off the
  // member dump (members slice) and written via the e-signed POST /lims/qc-capabilities.
  limsAudit: limsAudit.reducer,
  limsCommentLibrary: limsCommentLibrary.reducer,
  limsSpecs: limsSpecs.reducer,
  limsConsumables: limsConsumables.reducer,
  limsProductTestPlan: limsProductTestPlan.reducer,
  limsSampleQc: limsSampleQc.reducer,
  limsOos: limsOos.reducer,
  limsResults: limsResults.reducer,
  limsRelease: limsRelease.reducer,
  limsReviewSpec: limsReviewSpec.reducer,
  limsReviews: limsReviews.reducer,
  limsSstSpec: limsSstSpec.reducer,
  limsSstResult: limsSstResult.reducer,
  limsSstTemplates: limsSstTemplates.reducer,
  limsForskrifter: limsForskrifter.reducer,
  limsSpecVersions: limsSpecVersions.reducer,
  limsQaDecisions: limsQaDecisions.reducer,
  limsBatchHold: limsBatchHold.reducer,
  limsReruns: limsReruns.reducer,
  limsWorklistTemplates: limsWorklistTemplates.reducer,
  limsSampleWorklists: limsSampleWorklists.reducer,
  limsChangeControl: limsChangeControl.reducer,
})

export {
  message,
  visual,
  whiteTasks,
  analysisTasks,
  members,
  analyses,
  projectActions,
  assets,
  analysisDefinitions,
  teamStatus,
  auth,
  loading,
  projects,
  projectTemplates,
  competenceGroups,
  constraintChecks,
  metrics,
  iap,
  scheduleHover,
  customerAdministration,
  samples,
  seatInfo,
  diagnostics,
  sampleView,
  integrationSheets,
  teamsOnLocation,
  locations,
  teamInfo,
  multipleDrag,
  reports,
  dayPicker,
  waiting,
  scrumView,
  plannableSamples,
  analysisGroups,
  projectGroups,
  chatBot,
  librarian,
  repositories,
  // Common
  createMap,
  addToMap,
  removeFromMap,
  token,
  standardActions,
  logging,
  permissions,
  limsCapabilities,
  limsAudit,
  limsCommentLibrary,
  limsSpecs,
  limsConsumables,
  limsProductTestPlan,
  limsSampleQc,
  limsOos,
  limsResults,
  limsRelease,
  limsSampleQa,
  limsReviewSpec,
  limsReviews,
  limsSstSpec,
  limsSstResult,
  limsSstTemplates,
  limsForskrifter,
  limsSpecVersions,
  limsQaDecisions,
  limsBatchHold,
  limsReruns,
  limsWorklistTemplates,
  limsSampleWorklists,
  limsChangeControl,
}
